var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 812"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 672",
    x: 11.6875,
    width: 2.125,
    height: 4.28298,
    rx: 1.0625,
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 673",
    x: 3.1875,
    width: 2.125,
    height: 4.28298,
    rx: 1.0625,
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 674",
    y: 2.14148,
    width: 17,
    height: 16.8591,
    rx: 1.5,
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M7.15238 14.7848C7.5496 15.1435 8.14544 15.1435 8.54266 14.7848L12.6142 11.1077C13.0114 10.7489 13.0114 10.2108 12.6142 9.85207C12.217 9.49332 11.6211 9.49332 11.2239 9.85207L7.84752 12.9911L6.45724 11.7355C6.06002 11.3767 5.46418 11.3767 5.06696 11.7355C4.66974 12.0942 4.66974 12.6323 5.06696 12.9911L7.15238 14.7848Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 675",
    x: 0.429561,
    y: 5.91174,
    width: 16.1409,
    height: 0.859123,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.859123
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckIcon);
export default __webpack_public_path__ + "static/media/calendar-check-icon.2525702334bda0ea71c88b1f074b6a50.svg";
export { ForwardRef as ReactComponent };